export const ANIMAL_VIEW = "/animal"
export const NEW_ANIMAL_VIEW = "/animal/new"
export const ANIMAL_PROFILE_VIEW = "/animal-profile-path"
export const FARM_VIEW = "/farm"
